import ACTION_TYPES from 'constants/ACTION_TYPES';
import SERVICE_TYPES from 'constants/SERVICE_TYPES';
import { select, put } from 'redux-saga/effects';
import api from '../api/api';

function* fetchMembers(page = 1, per_page = 10, apiUrl,searchTerm = '',brand) {
    let url = `/community/members?page=${page}&per_page=${per_page}`;
    if(!!searchTerm){
        url += `&term=${searchTerm}`;
    }
    if(!!brand && brand!=='all'){
        url += `&brands=${brand}`;
    }

    const getSelectedRegion = state => state.user.selectedRegion;
    const selectedRegion = yield select(getSelectedRegion);

    const json = yield api.get(url, apiUrl, selectedRegion, SERVICE_TYPES.COMMUNITY);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_MEMBERS_RESPONSE,
            data: {
                list: json.results,
                page: json.page,
                per_page: json.per_page,
                total: json.total,
                total_pages: json.total_pages,
            },
        });
    }
}

function* getMember(memberId, apiUrl) {
    const json = yield api.get(`/community/members/${memberId}`, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_GET_MEMBER_RESPONSE,
            data: json,
        });
    }
}

function* getExpertCoaches(region_ident = 'all', apiUrl) {
    const json = yield api.get(`/community/members?member_type=expert_coach&per_page=100`, apiUrl, region_ident, SERVICE_TYPES.COMMUNITY);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_EXPERT_COACHES_RESPONSE,
            data: json.results,
        });
    }
}

function* csMembersWorker(apiUrl, action) {
    switch (action.type) {
        case ACTION_TYPES.CS_FETCH_MEMBERS_REQUEST:
            yield fetchMembers(
                action.data?.page,
                action.data?.per_page,
                apiUrl,
                action.data?.searchTerm,
                action.data?.brand
            );
            break;
        case ACTION_TYPES.CS_GET_MEMBER_REQUEST:
            yield getMember(action.data, apiUrl);
            break;
        case ACTION_TYPES.CS_FETCH_EXPERT_COACHES_REQUEST:
            yield getExpertCoaches(action?.data?.region_ident, apiUrl);
            break;
        default:
            break;
    }
}

export default csMembersWorker;
